import React from 'react';
import { fromGlobalId } from 'graphql-relay';
import get from 'lodash/get';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { getWeek, getWeekStart, getWeekEnd } from '../RepVisitsSearchPage/date-utils';
import Grid from '../../components/Grid';
import VisitsAvailabilitySingle from '../VisitsAvailabilitySingle';
import VisitReschedule from '../VisitReschedule';
import RepVisitsWeekOf from '../RepVisitsSearchPage/repvisits-week-of';
import messages from './messages';

import Button from '../../components/Button';
import DatePicker from '../../components/DatePicker';
import Icon from '../../components/Icon';
import Popup from '../../components/Popup';
import Header from '../../components/Header';

import './styles.css';

class EventReschedule extends React.PureComponent {
  static propTypes = {
    highSchool: PropTypes.object,
    dayId: PropTypes.string,
    appointmentId: PropTypes.string,
    defaultDate: PropTypes.string,
    toggleReschedule: PropTypes.func,
    onReschedule: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    const date = new Date(`${props.defaultDate}T12:00:00`);

    this.state = {
      dateFrom: getWeekStart(date),
      dateTo: getWeekEnd(date),
      showDatePicker: false,
      rescheduleModalOpen: false,
      bookDayId: null,
      bookAppointmentId: null,
    };
  }

  handleDatePickerChanged = (day) => {
    this.setState({
      dateFrom: getWeekStart(day),
      dateTo: getWeekEnd(day),
      showDatePicker: false,
    });
  };

  changeDates(days) {
    this.setState((prevState) => {
      const newFrom = new Date(prevState.dateFrom);
      newFrom.setDate(newFrom.getDate() + days);
      const newTo = new Date(prevState.dateTo);
      newTo.setDate(newTo.getDate() + days);
      return { dateFrom: newFrom, dateTo: newTo };
    });
  }

  toggleDatePicker = () => {
    this.setState((prevState) => ({ showDatePicker: !prevState.showDatePicker }));
  };

  viewPrevWeek = (event) => {
    this.changeDates(-7);
  };

  viewNextWeek = (event) => {
    this.changeDates(7);
  };

  closeModal = () => { this.setState({ rescheduleModalOpen: false }); };

  openModal = (schoolId, bookDayId, bookAppointmentId) => {
    this.setState({ rescheduleModalOpen: true, bookAppointmentId, bookDayId });
  };

  render() {
    const { highSchool, toggleReschedule, intl, onReschedule, dayId, appointmentId } = this.props;
    const { bookDayId, bookAppointmentId, dateFrom, dateTo, showDatePicker, rescheduleModalOpen } = this.state;
    const schoolId = fromGlobalId(get(highSchool, 'id', '')).id;
    const name = get(highSchool, 'name');

    const week = getWeek(dateFrom);
    return (
      <div styleName="sidebar">
        <Header as="h1" styleName="header-text">
          {name}
        </Header>
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column styleName="week-showing">
              <Header styleName="section-title required" size="small">
                <FormattedMessage {...messages.rescheduleTitle} />
              </Header>
              <FormattedMessage {...messages.showingWeek} />
              <RepVisitsWeekOf dateFrom={dateFrom} dateTo={dateTo} />
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Popup
                trigger={(
                  <Button
                    size="small"
                    labelPosition="right"
                    icon={<Icon name="calendar outline" />}
                    content={intl.formatMessage(messages.selectWeek)}
                  />
)}
                on="click"
                open={showDatePicker}
                onClose={this.toggleDatePicker}
                onOpen={this.toggleDatePicker}
              >
                <DatePicker
                  selectedDays={{ from: dateFrom, to: dateTo }}
                  initialMonth={dateFrom}
                  onDayClick={this.handleDatePickerChanged}
                  enableOutsideDays
                />
              </Popup>
              <Button.Group size="small" as="span">
                <Button
                  data-cy="previousWeek"
                  icon="triangle left"
                  onClick={this.viewPrevWeek}
                  aria-label={intl.formatMessage(messages.prevWeek)}
                />
                <Button
                  data-cy="nextWeek"
                  icon="triangle right"
                  onClick={this.viewNextWeek}
                  aria-label={intl.formatMessage(messages.nextWeek)}
                />
              </Button.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <VisitsAvailabilitySingle
              schoolId={schoolId}
              fromDate={week[0]}
              toDate={week[4]}
              onAppointmentClick={this.openModal}
              week={week}
            />
          </Grid.Row>
          <Grid.Row>
            <Button
              onClick={toggleReschedule}
              aria-label={intl.formatMessage(messages.prevWeek)}
              floated="right"
            >
              Back
            </Button>
          </Grid.Row>
          {bookDayId && (
          <VisitReschedule
            bookDayId={bookDayId}
            cancelDayId={dayId}
            bookAppointmentId={bookAppointmentId}
            cancelAppointmentId={appointmentId}
            open={rescheduleModalOpen}
            onConfirm={onReschedule}
            onClose={this.closeModal}
          />
          )}
        </Grid>
      </div>
    );
  }
}

export default injectIntl(EventReschedule);
